<template>
  <div :class="$route.name == '/homework_report' ? 'wrapper_pad' : 'wrapper'">
    <!-- 预览 -->
    <el-dialog
      :title="'预览：' + (prew_content.title || prew_content.name)"
      :visible.sync="dialogVisible_previewData"
      width="50%"
      custom-class="sign_course_edit_rich_guide_dia_prew"
    >
      <previewData
        v-if="dialogVisible_previewData"
        :prew_type="prew_type"
        :prew_content="prew_content"
      ></previewData>
    </el-dialog>

    <el-dialog
      title="设置"
      :visible.sync="parameterDialogVisible"
      width="40%"
      center
    >
      <div class="flex-col">
        <span style="margin: 20px 0px">比率临界值(占总分的%)：</span>

        <div class="flex-row-v-center marginB">
          <span>优秀：</span>
          <div>
            <el-input-number
              v-model="parameter.excellent"
              :min="1"
              :max="100"
            ></el-input-number
            >%
          </div>
        </div>
        <div class="flex-row-v-center marginB">
          <span>良好：</span>
          <div>
            <el-input-number
              v-model="parameter.good"
              :min="1"
              :max="parameter.excellent - 1"
            ></el-input-number
            >%
          </div>
        </div>
        <div class="flex-row-v-center marginB">
          <span>及格：</span>
          <div>
            <el-input-number
              v-model="parameter.pass"
              :min="1"
              :max="parameter.good - 1"
            ></el-input-number
            >%
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="parameterDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="onSave">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="
        show_type == 1
          ? '未提交学生（' + summary.un_submit_list.length + '）'
          : show_type == 2
          ? '未批改学生（' + summary.un_correction_list.length + '）'
          : '超时提交学生（' + summary.overtime_list.length + '）'
      "
      :visible.sync="dialogVisible"
      width="50%"
      custom-class="studen_list_dia"
    >
      <div class="student_list_dia">
        <div
          class="student_list_dia_item"
          v-for="(item, index) in show_type == 1
            ? summary.un_submit_list
            : show_type == 2
            ? summary.un_correction_list
            : summary.overtime_list"
          :key="index"
        >
          {{ item.name }}
        </div>
      </div>
    </el-dialog>
    <!-- 单独发送小红花 -->
    <el-dialog
      :title="student_info.name"
      :visible.sync="send_flower_once_dia"
      width="30%"
      custom-class="studen_list_dia"
    >
      <div class="">
        <div style="">
          <div style="margin: 10px 0">奖扣小红花数量：</div>
          <el-input-number size="" v-model="flower_num_once"></el-input-number>
        </div>
        <div style="">
          <div style="margin: 10px 0">奖扣理由：</div>
          <el-input
            v-model="flower_once_reason"
            placeholder="请输入奖扣理由"
          ></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer" style="text-align: center">
        <el-button @click="send_flower_once_dia = false">取 消</el-button>
        <el-button type="primary" @click="send_flower_once_confirm()"
          >发 送</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="奖扣小红花"
      :visible.sync="dialogVisible_flower"
      width="50%"
      custom-class="flower_dia"
    >
      <el-tabs v-model="activeName" @tab-click="change_send_type">
        <el-tab-pane label="批量发送" name="first">
          <div>
            <div style="color: #999999; font-size: 12px">
              设置各个等级小红花奖惩数量<span style="color: red"
                >（为防止重复发送小红花，请尽量在批改完所有学生作业后发送！）</span
              >
            </div>
            <div style="margin: 20px 0">
              未完成：<el-input-number
                size="mini"
                v-model="un_submit_flower"
                @blur="!un_submit_flower ? (un_submit_flower = 0) : ''"
              ></el-input-number>
            </div>
            <div style="display: flex; margin-bottom: 20px">
              <div>
                优<span style="opacity: 0">优</span>秀：<el-input-number
                  size="mini"
                  v-model="excellent_flower"
                  @blur="!excellent_flower ? (excellent_flower = 0) : ''"
                ></el-input-number>
              </div>
              <div style="margin-left: 20px">
                良<span style="opacity: 0">良</span>好：<el-input-number
                  size="mini"
                  v-model="fine_flower"
                  @blur="!fine_flower ? (fine_flower = 0) : ''"
                ></el-input-number>
              </div>
            </div>
            <div style="display: flex; margin-bottom: 20px">
              <div>
                及<span style="opacity: 0">及</span>格：<el-input-number
                  size="mini"
                  v-model="pass_flower"
                  @blur="!pass_flower ? (pass_flower = 0) : ''"
                ></el-input-number>
              </div>
              <div style="margin-left: 20px">
                不及格：<el-input-number
                  size="mini"
                  v-model="fail_flower"
                  @blur="!fail_flower ? (fail_flower = 0) : ''"
                ></el-input-number>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="单独发送" name="second">
          <div style="color: #999999; font-size: 12px">
            <span style="color: red">（单独发送数量与批量发送数量累加！）</span>
          </div>
          <div style="height: 50vh; overflow: auto">
            <el-table
              :data="all_student_list_flower"
              style="width: 100%"
              height="100%"
              :row-class-name="tableRowClassName"
            >
              <el-table-column prop="name" label="姓名" width="180">
              </el-table-column>
              <el-table-column prop="grade" label="完成情况" width="180">
              </el-table-column>
              <el-table-column prop="precision_num" label="得分率">
              </el-table-column>
              <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                  <!-- <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button> -->
                  <el-button
                    type="text"
                    size="small"
                    @click="send_flower_once(scope.row)"
                    >奖扣小红花</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
      </el-tabs>
      <span slot="footer" class="dialog-footer" style="text-align: center">
        <el-button @click="dialogVisible_flower = false">取 消</el-button>
        <el-button
          type="primary"
          v-if="activeName == 'first'"
          @click="send_flower()"
          >发 送</el-button
        >
        <!-- <el-button type="primary" v-if="activeName=='second'" @click="dialogVisible = false;send_flower_once()" >发 送</el-button> -->
      </span>
    </el-dialog>

    <!-- 作业附件 -->
    <el-dialog
      title="作业附件"
      :visible.sync="fileDialogVisible"
      width="50%"
      center
    >
      <div>
        <el-table :data="attachfile" stripe style="width: 100%">
          <el-table-column type="index" width="50"> </el-table-column>
          <el-table-column prop="name" label="文件名"> </el-table-column>
          <el-table-column prop="type" label="文件类型"> </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button size="mini" @click="preview(scope.$index, scope.row)"
                >预览</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <div class="head" v-if="$route.name != '/homework_report'">
      <div @click="$router.push('/homework?isShowHomeWorkIndex=3')">
        <img src="../../assets/images/course_2.0/返回.png" alt="" />
      </div>
      <div class="item_content_item_title">
        {{ $route.query.homework_title }}(
        {{
          $route.query.assigned == 0
            ? "老师批改"
            : $route.query.assigned == 1
            ? "学生互批"
            : "学生自批"
        }})
      </div>
      <div class="flex-row-center set_flower_box">
        <div class="head_set_flower">
          <div @click="set_flower()">奖扣小红花</div>
        </div>
        <div
          class="head_set_flower"
          v-if="attachfile.length != 0"
          style="margin-left: 10px"
        >
          <div @click="fileDialogVisible = true">作业附件</div>
        </div>
      </div>
      <div @click="$router.push('/homework?isShowHomeWorkIndex=3')" style='opacity: 0;'>
        <img src="../../assets/images/course_2.0/返回.png" alt="" />
      </div>
    </div>
    <div class="nav flex-row-space-between">
      <div
        :class="{ navItem: true, navItemActive: activeIndex == 1 }"
        @click="activeNav('1')"
      >
        <span> 作业分析</span>
        <div style="height: 5px">
          <div :class="{ navLine: activeIndex == 1 }"></div>
        </div>
      </div>
      <div
        :class="{ navItem: true, navItemActive: activeIndex == 2 }"
        @click="activeNav('2')"
      >
        <span> 习题分析</span>
        <div style="height: 5px">
          <div :class="{ navLine: activeIndex == 2 }"></div>
        </div>
      </div>
      <div
        :class="{ navItem: true, navItemActive: activeIndex == 3 }"
        @click="activeNav('3')"
      >
        <span> 错题集</span>
        <div style="height: 5px">
          <div :class="{ navLine: activeIndex == 3 }"></div>
        </div>
      </div>
    </div>
    <div v-if="activeIndex == 1" class="report_content">
      <div>
        <div class="item_title_detail">
          <!-- <div>作业概况</div>
          <div style="opacity: 0">查看详情</div> -->
        </div>
        <div class="item_content">
          <div class="item_content_item">
            <div class="item_content_item_title">
              提交率：{{ (summary.submit_ratio * 100).toFixed(2) }}%
            </div>
            <div class="item_content_item_data">
              <div>已提交：{{ summary.submit_num }}</div>
              <div
                @click="
                  dialogVisible = true;
                  show_type = 1;
                "
              >
                未提交：{{ summary.un_submit_list.length || 0 }}
              </div>
            </div>
          </div>
          <div class="item_content_item">
            <div class="item_content_item_title">
              批改率：{{ (100 * summary.correction_ratio).toFixed(2) }}%
            </div>
            <div class="item_content_item_data">
              <div>已批改：{{ summary.correction_num }}</div>
              <div
                @click="
                  dialogVisible = true;
                  show_type = 2;
                "
              >
                未批改：{{ summary.un_correction_list.length || 0 }}
              </div>
            </div>
          </div>
          <div
            class="item_content_item"
            v-if="summary.duration == 0"
            style="opacity: 0"
          >
            <div class="item_content_item_title">平均用时：0秒</div>
            <div class="item_content_item_data">
              <div>正常：0</div>
              <div>超时：0</div>
            </div>
          </div>
          <div class="item_content_item" v-if="summary.duration > 0">
            <div class="item_content_item_title">
              平均用时：{{ summary.verage_time.toFixed(2) }}秒
            </div>
            <div class="item_content_item_data">
              <div>正常：{{ summary.intime_num }}</div>
              <div
                @click="
                  dialogVisible = true;
                  show_type = 3;
                "
              >
                超时：{{ summary.overtime_list.length || 0 }}
              </div>
            </div>
          </div>
        </div>
        <div class="item_content2" v-if="this.achievementList.length != 0">
          <div class="flex-col-center">
            <div class="fraction">
              {{ this.achievementList[0].total_score || "-" }}
            </div>
            <div>试卷总分</div>
          </div>
          <div class="flex-col-center">
            <div class="fraction">
              {{ this.achievementList[0].precision_num || "-" }}
            </div>
            <div>试卷最高分</div>
          </div>
          <div class="flex-col-center">
            <div class="fraction">
              {{
                this.achievementList[this.achievementList.length - 1]
                  .precision_num || "-"
              }}
            </div>
            <div>试卷最低分</div>
          </div>
          <div class="flex-col-center">
            <div class="fraction">
              {{ average || "-" }}
            </div>
            <div>平均分</div>
          </div>
        </div>
        <!-- 成绩 -->
        <div class="item_title_detail">
          <!-- <div>成绩概况</div>
          <div @click="parameterDialogVisible = true">参数设置</div> -->
        </div>
        <div class="item_result">
          <div class="result_l">
            <div class="item_title_detail" style="margin: 10px">
              <div>成绩概况</div>
              <div @click="parameterDialogVisible = true">参数设置</div>
            </div>

            <div id="chartPie"></div>
          </div>
          <div class="result_r">
            <div class="result_rTitle flex-row-space-between">
              <span> 提示：点击学生名字可查看单个学生的作业分析报告
              </span>
              <download-excel class="export-excel-wrapper" :data="DetailsForm" :fields="json_fields" name="学生成绩.xls">
              <!-- 上面可以自定义自己的样式，还可以引用其他组件button -->
              <div class="homeWorkItemBtn " @click="onImport">导出成绩</div>
            </download-excel>
            </div>
            
            <div class="result_r_content" v-if="achievementList.length != 0">
              <!-- 优秀 -->
              <div
                v-for="(item_student, index_student) in summary
                  .precision_statistics_list[0]"
                :key="index_student"
                class="flex-row-v-center result_r_contentBox color1"
                @click="getDetail(item_student)"
              >
                <span class="indexNum flex-center">{{
                  index_student + 1
                }}</span>
                <div class="result_r_content_item">
                  {{ item_student.name }}
                </div>
                <div class="scoreBox flex-center">
                  <span class="scoreNum">{{ item_student.precision_num }}</span
                  ><span style="font-size: 6px">分</span>
                </div>
              </div>
              <!-- 良好 -->
              <div
                v-for="(item_student, index_student) in summary
                  .precision_statistics_list[1]"
                :key="index_student + '-only'"
                class="flex-row-v-center result_r_contentBox color2"
                @click="getDetail(item_student)"
              >
                <span class="indexNum flex-center">{{
                  summary.precision_statistics_list[0].length +
                  index_student +
                  1
                }}</span>
                <div class="result_r_content_item">
                  {{ item_student.name }}
                </div>
                <div class="scoreBox2 flex-center">
                  <span class="scoreNum">{{ item_student.precision_num }}</span
                  ><span style="font-size: 6px">分</span>
                </div>
              </div>
              <!-- 及格 -->
              <div
                v-for="(item_student, index_student) in summary
                  .precision_statistics_list[2]"
                :key="index_student + '-only1'"
                class="flex-row-v-center result_r_contentBox color3"
                @click="getDetail(item_student)"
              >
                <span class="indexNum flex-center">{{
                  summary.precision_statistics_list[0].length +
                  summary.precision_statistics_list[1].length +
                  index_student +
                  1
                }}</span>
                <div class="result_r_content_item">
                  {{ item_student.name }}
                </div>
                <div class="scoreBox3 flex-center">
                  <span class="scoreNum">{{ item_student.precision_num }}</span
                  ><span style="font-size: 6px">分</span>
                </div>
              </div>
              <!-- 不及格 -->
              <div
                v-for="(item_student, index_student) in summary
                  .precision_statistics_list[3]"
                :key="index_student + '-only2'"
                class="flex-row-v-center result_r_contentBox color4"
                @click="getDetail(item_student)"
              >
                <span class="indexNum flex-center">{{
                  summary.precision_statistics_list[0].length +
                  summary.precision_statistics_list[1].length +
                  summary.precision_statistics_list[2].length +
                  index_student +
                  1
                }}</span>
                <div class="result_r_content_item">
                  {{ item_student.name }}
                </div>
                <div class="scoreBox4 flex-center">
                  <span class="scoreNum">{{ item_student.precision_num }}</span
                  ><span style="font-size: 6px">分</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 习题详情 -->
        <div class="item_title_detail">
          <!-- <div>习题分析</div>
          <div style="opacity: 0">查看详情</div> -->
        </div>
        <div class="grade_detail">
          <!-- <div>点击查看详情</div> -->
          <div class="item_content3" v-if="this.achievementList.length != 0">
            <div class="flex-col-center">
              <div>总共</div>
              <div class="fraction">
                {{ this.achievementList[0].tiku_num || "-" }}题
              </div>
            </div>
            <div class="flex-col-center">
              <div>答对(得分率=100%)</div>
              <div class="fraction">{{ fullScorequantity }}题</div>
            </div>
            <div class="flex-col-center">
              <div>答错(得分率<100%)</div>
              <div class="fraction">
                {{ this.achievementList[0].tiku_num - fullScorequantity }}题
              </div>
            </div>
          </div>
          <div class="grade_detail_itemBox">
            <div
              class="grade_detail_item"
              v-for="(item, index) in topic_detail_list"
              :key="index"
              @click="to_topic_detail(item, index)"
            >
              <el-progress
                v-if="parseInt(item.accuracy) || parseInt(item.accuracy) == 0"
                class="grade_detail_item_circle"
                :format="format"
                type="circle"
                :percentage="item.accuracy"
              ></el-progress>
              <div>{{ index + 1 }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="activeIndex == 2" class="report_content">
      <router-view></router-view>
    </div>
    <div v-if="activeIndex == 3" class="report_content flex-row">
      <div class="studentListBox">
        <div
          :class="{ allStudent: true, activeallStudent: !activeId }"
          @click="getAllStudent"
        >
          全部学生
        </div>
        <div
          :class="{ studentItem: true, activestudentItem: activeId == item.id }"
          v-for="(item, index) in achievementList"
          :key="index"
          @click="selectStudent(item)"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="topiclistBox flex-col">
        <div class="topiclistBoxHead">
          <div class="flex-row-v-center">
            <span class="topiclistBoxHeadTitle">错题数：</span>
            <span class="topiclistBoxHeadNum">{{ wrongTopicList.length }}</span>
          </div>
        </div>
        <div class="topiclistBoxContent">
          <div
            class="topiclistItem"
            v-for="(item, index) in wrongTopicList"
            :key="index"
          >
            <div class="topiclistItemContent" v-html="item.content"></div>
            <div
              class="flex-row-space-between"
              v-for="(data, key) in topic_detail_list"
              :key="key"
            >
              <div class="accuracyTitle" v-if="item.uuid == data.uuid">
                得分率:{{ data.accuracy }}%
              </div>
              <div class="flex-row-center" v-if="item.uuid == data.uuid">
                <div
                  class="flex-row-v-center analysis"
                  @click="item_answer_show(item)"
                >
                  <img
                    src="../../assets/images/course_2.0/analysis_.png"
                    alt=""
                  />
                  {{ item.answer_show ? "收起解析" : "解析" }}
                </div>

                <div
                  class="topic_btnItem"
                  v-if="srcUuidsList.indexOf(item.uuid) == -1"
                  @click="addTikuCart(item)"
                >
                  加入组题篮
                </div>
                <div
                  class="topic_btnItem"
                  style="background: #999999"
                  @click="cancelJoin(item)"
                  v-else
                >
                  已加入组题篮
                </div>
              </div>
            </div>

            <div class="topic_answer_analyzing2" v-if="item.answer_show">
              <div>[答案]</div>
              <div
                v-if="!Array.isArray(item.answer)"
                v-html="item.answer"
              ></div>
              <div v-else>
                <div
                  v-for="(data, key) in item.answer"
                  :key="key"
                  v-html="data"
                ></div>
              </div>
              <div>[解析]</div>
              <div v-html="item.analyzing"></div>
            </div>

            <div class="topiclistItemLine"></div>
            <div v-if="!activeId">
              <div class="topiclistItemFooter">
                回答正确:
                <span
                  v-if="item.answerIincorrectly.indexOf(val.name) == -1"
                  style="margin-right: 5px"
                  v-for="(val, keyValue) in achievementList"
                  :key="keyValue"
                  >{{ val.name }}</span
                >
              </div>
              <div class="topiclistItemFooter">
                回答错误:
                <span
                  style="margin-right: 5px"
                  v-for="(value, id) in item.answerIincorrectly"
                  :key="id"
                  >{{ value }}</span
                >
              </div>
            </div>
          </div>
          <div v-if="wrongTopicList.length == 0">
            <el-empty description="暂无错题"></el-empty>
          </div>
        </div>
      </div>
    </div>
    <div class="testQuestions" v-if="activeIndex == 3">
      <div class="flex-row">
        <div class="testQuestionsBox flex-col-v-center" @click.stop="enter">
          <div
            class="testBtn flex-center"
            @click.stop="isShowTestList = !isShowTestList"
          >
            作业篮
          </div>
          <img src="../../assets/images/course_2.0/carticon.png" alt="" />
          <span class="tikuName" :title="tikuCartGroupName">{{
            tikuCartGroupName
          }}</span>
          <div class="numClass">{{ tikuCartListNum }}</div>
        </div>
        <div :class="{ testList: true, isShowTestList: isShowTestList }">
          <div
            :class="{
              testListItem: true,
              'flex-center': true,
              testListItemActive: tikuCartGroupId == item.group_id,
            }"
            :title="item.name"
            v-for="(item, index) in tikuCartGroupList"
            :key="index"
            @click.stop="switchTestList(item)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
    <!-- 习题篮列表 -->
    <div class="tipTiku flex-col" v-show="isShowTikuTip">
      <div class="flex-row-space-between" style="margin-bottom: 14px">
        <div class="tipHead">
          <span>已选择习题：</span>
          <span style="color: #ff9b36">{{ tikuCartListNum }}习题</span>
        </div>
        <div style="cursor: pointer" @click="batchDelTiku">
          <img
            style="width: 20px; height: 20px"
            src="../../assets/images/course_2.0/allDelete.png"
            alt=""
          />
        </div>
      </div>
      <div
        v-if="tikuCartListNum > 0"
        class="flex-1"
        style="overflow-y: auto; overflow-x: hidden; margin-bottom: 10px"
      >
        <div
          class="tikuListItem flex-row-space-between"
          v-for="(item, index) in tikuCartList"
          :key="index"
        >
          <div class="tikuTypeName">
            {{ change_topic_type(item.type_id) }}
          </div>
          <div>{{ item.list.length }}</div>
          <div>
            <div style="cursor: pointer" @click="delCourseTiku(item.type_id)">
              <img
                style="width: 16px; height: 16px"
                src="../../assets/images/course_2.0/delete.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      <div v-else class="flex-1">
        <el-empty :image-size="50" style="padding: 20px 0"></el-empty>
      </div>
      <div @click="goPage('0')" class="tipBtn flex-center">组卷预览</div>
      <div class="trangle"></div>
    </div>
  </div>
</template>
<script>
import echarts from "echarts";
import bus from "../../plugins/Bus";
// import app_richText from "../../components/rich/app_richText.vue";
import ifram from "../../components/ifarm/ifarm";
import previewData from "../../components/common_module/preview_data.vue";
export default {
  components: { ifram, previewData },
  data() {
    return {
      DetailsForm: [],
      json_fields: {
        学生姓名: "name",
        成绩:"precision_num",
        总分:"total_score"
      },
      chapter_code:'',
      isShowTestList: false,
      isShowTip: false,
      isShowTikuTip: false,
      tikuCartListNum: 0,
      tikuCartGroupList: [],
      tikuCartGroupName: "",
      tikuCartGroupId: "",
      tikuLabelList: [],
      srcUuidsList: [],
      activeId: "", //选中的ID
      wrongTopicList: [],
      fullScorequantity: "",
      average: "",
      activeIndex: 1,
      prew_content: "",
      prew_type: "",
      parameterDialogVisible: false,
      fileDialogVisible: false,
      dialogVisible_previewData: false,
      attachfile: [],
      parameter: {
        excellent: 85,
        good: 70,
        pass: 60,
      },
      achievementList: [],
      flower_once_reason: "",
      student_info: "",
      send_flower_once_dia: false,
      flower_num_once: 0,
      all_student_list_flower: [],
      activeName: "first",
      dialogVisible_flower: false,
      dialogVisible: false,
      student_arr: [], //学生得分情况 暂时没用
      student_arr_type: [], //按等级分类学生
      student_arr_type_active: 0,
      summary: {
        un_submit_list: [],
        un_correction_list: [],
        overtime_list: [],
        precision_statistics_list: [],
        submit_ratio: 0,
        correction_ratio: 0,
        verage_time: 0,
      }, //学生得分情况
      show_type: 1,
      topic_detail_list: [],
      un_submit_flower: -1,
      excellent_flower: 3,
      fine_flower: 2,
      pass_flower: 1,
      fail_flower: 0,
    };
  },
  mounted() {
    this.get_correct_work();
    this.gettikuLabel();
    this.getTikuCartGroupList();
  },
  methods: {
    onImport(){},
    //跳到组卷预览
    goPage(data) {
      let textbook_guid = sessionStorage.getItem("text_book_guid");
      if (data == 1) {
        window.open(
          `https://www.gaokaowin.com/huixuebao/exam/#/combinationhxb?group_id=${JSON.parse(sessionStorage.userInfo).id}_0&chapter_code=${this.chapter_code}&textbook_guid=${textbook_guid}&from=hxb_homework&is_temporary=1`,
          "_self"
        );
      } else {
        window.open(
          `https://www.gaokaowin.com/huixuebao/exam/#/combinationhxb?group_id=${this.tikuCartGroupId}&chapter_code=${this.chapter_code}&textbook_guid=${textbook_guid}&from=hxb_homework`,
          "_self"
        );
      }
    },
    cancelJoin(item) {
      let params = {
        tiku_uuid: item.uuid || item.tiku_uuid,
        group_id: this.tikuCartGroupId,
      };
      this.axios.post("/school/cart/delTikuCart", params).then((res) => {
        if (res.data.code == 1) {
          this.$message({
            type: "success",
            message: "取消成功",
          });
          this.getTikuCartList(this.tikuCartGroupId);
        }
      });
    },
    //切换试题篮
    switchTestList(item) {
      this.tikuCartGroupName = item.name;
      this.tikuCartGroupId = item.group_id;
      this.isShowTestList = false;
      this.getTikuCartList(this.tikuCartGroupId);
    },
    enter() {
      this.isShowTip = !this.isShowTip;
      this.isShowTikuTip = !this.isShowTikuTip;
    },
    //批量删除
    batchDelTiku() {
      this.$confirm("此操作将删除此组卷篮内容, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          group_id: this.tikuCartGroupId,
        };
        this.axios.post("/school/cart/delTikuCart", params).then((res) => {
          if (res.data.code == 1) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getTikuCartList(this.tikuCartGroupId);
          }
        });
      });
    },
    //获取习题篮/school/cart/tikuCartGroupList
    getTikuCartGroupList() {
      this.axios.get("/school/cart/tikuCartGroupList").then((res) => {
        if (res.data.code == 1) {
          this.tikuCartGroupList = res.data.data.data;
          this.tikuCartGroupName = this.tikuCartGroupList[0].name;
          this.tikuCartGroupId = this.tikuCartGroupList[0].group_id;
          for (let i in this.tikuCartGroupList) {
            if (this.tikuCartGroupList[i].checked == 1) {
              this.tikuCartGroupName = this.tikuCartGroupList[i].name;
              this.tikuCartGroupId = this.tikuCartGroupList[i].group_id;
            }
          }
          this.getTikuCartList(this.tikuCartGroupId);
        }
      });
    },
    //获取对应试题篮列表/school/cart/tikuCartList
    getTikuCartList(id) {
      let params = {
        group_id: id,
      };
      this.axios.post("/school/cart/tikuCartList", params).then((res) => {
        if (res.data.code == 1) {
          this.tikuCartList = res.data.data.data;
          this.srcUuidsList = res.data.data.src_uuids;

          this.tikuCartListNum = res.data.data.count;
        }
      });
    },
    //获取习题类别
    gettikuLabel() {
      let params = {
        subject_code: JSON.parse(sessionStorage.userInfo).subject_code,
      };
      this.axios.post("/teacher/subject/gettikutype", params).then((res) => {
        if (res.data.code == 1) {
          this.tikuLabelList = JSON.parse(res.data.data.type_json);
          this.tikuLabelList.unshift({ n: "全部", id: "" });
        }
      });
    },
    change_topic_type(id) {
      for (let i in this.tikuLabelList) {
        if (this.tikuLabelList[i].id == id) {
          return this.tikuLabelList[i].n;
        }
      }
    },
    //删除题型
    delCourseTiku(id) {
      this.$confirm("此操作将删除此题型, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          group_id: this.tikuCartGroupId,
          type_id: id,
        };
        this.axios.post("/school/cart/delTikuCart", params).then((res) => {
          if (res.data.code == 1) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getTikuCartList(this.tikuCartGroupId);
          }
        });
      });
    },
    //加入对应试题篮
    addTikuCart(item) {
      for (let i in this.tikuLabelList) {
        if (this.tikuLabelList[i].id == item.type_id) {
          item.type_name = this.tikuLabelList[i].n;
        }
      }
      let params = {
        group_id: this.tikuCartGroupId,
        tikus: [
          {
            src_uuid: item.uuid || item.tiku_uuid,
            type_id: item.type_id,
            type_name: item.type_name,
          },
        ],
      };
      if (this.type_first == "cloud") {
        params.is_cloud = 1;
      } else {
        params.is_cloud = "";
      }
      this.axios.post("/school/cart/addTikuCart", params).then((res) => {
        if (res.data.code == 1) {
          this.$message({
            type: "success",
            message: "添加成功",
          });
          this.getTikuCartList(this.tikuCartGroupId);
        }
      });
    },

    item_answer_show(item) {
      item.answer_show = !item.answer_show;
      this.$forceUpdate();
    },
    getAllStudent() {
      this.activeId = "";
      this.get_correct_work();
    },
    selectStudent(item) {
      this.activeId = item.id;
      console.log(item);
      let arr = [];
      item.topiclist.forEach((item) => {
        if (item.score != item.src_score) {
          arr.push(item);
        }
      });
      this.wrongTopicList = arr;
    },

    activeNav(item, index) {
      this.activeIndex = item;
      index = index || 0;
      if (item == 1 || item == 3) {
        this.$router.push(
          "/homework/homework_report" +
            "?index=" +
            0 +
            "&homework_src_uuid=" +
            this.$route.query.homework_src_uuid +
            "&class_id=" +
            this.$route.query.class_id +
            "&batch_id=" +
            this.$route.query.batch_id +
            "&homework_title=" +
            this.$route.query.homework_title +
            "&assigned=" +
            this.$route.query.assigned
        );
        this.activeId = "";
        this.get_correct_work();
      }
      if (item == 2) {
        this.$router.push(
          "/homework/homework_report/homework_report_topic" +
            "?index=" +
            index +
            "&homework_src_uuid=" +
            this.$route.query.homework_src_uuid +
            "&class_id=" +
            this.$route.query.class_id +
            "&batch_id=" +
            this.$route.query.batch_id +
            "&homework_title=" +
            this.$route.query.homework_title +
            "&assigned=" +
            this.$route.query.assigned
        );
      }
    },
    getDetail(item) {
      this.$router.push(
        `/homework/personal_report?batch_id_by_class=${item.batch_id_by_class}&usages_id=${item.id}&student_uuid=${item.student_uuid}&student_name=${item.name}`
      );
    },
    preview(index, data) {
      this.prew_content = data;
      this.prew_type = data.type;
      this.dialogVisible_previewData = true;
    },
    onSave() {
      this.get_correct_work();
      this.parameterDialogVisible = false;
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 1) {
        return "warning-row";
      }
      return "";
    },
    to_topic_detail(item, index) {
      this.activeNav("2", index);
    },
    format(percentage) {
      return `得分率 ${percentage}%`;
    },
    set_flower() {
      this.dialogVisible_flower = true;
      let all_student_list = [];
      for (let i in this.summary.precision_statistics_list[0]) {
        let item_temp = this.summary.precision_statistics_list[0][i];
        all_student_list.push({
          name: item_temp.name,
          student_uuid: item_temp.student_uuid,
          grade: "优秀",
          precision_num: item_temp.precision_num,
        });
      }
      for (let i in this.summary.precision_statistics_list[1]) {
        let item_temp = this.summary.precision_statistics_list[1][i];
        all_student_list.push({
          name: item_temp.name,
          student_uuid: item_temp.student_uuid,
          grade: "良好",
          precision_num: item_temp.precision_num,
        });
      }
      for (let i in this.summary.precision_statistics_list[2]) {
        let item_temp = this.summary.precision_statistics_list[2][i];
        all_student_list.push({
          name: item_temp.name,
          student_uuid: item_temp.student_uuid,
          grade: "及格",
          precision_num: item_temp.precision_num,
        });
      }
      for (let i in this.summary.precision_statistics_list[3]) {
        let item_temp = this.summary.precision_statistics_list[3][i];
        all_student_list.push({
          name: item_temp.name,
          student_uuid: item_temp.student_uuid,
          grade: "不及格",
          precision_num: item_temp.precision_num,
        });
      }
      for (let i in this.summary.un_correction_list) {
        let item_temp = this.summary.un_correction_list[i];
        all_student_list.push({
          name: item_temp.name,
          student_uuid: item_temp.student_uuid,
          grade: "未批改",
          precision_num: 0,
        });
      }
      for (let i in this.summary.un_submit_list) {
        let item_temp = this.summary.un_submit_list[i];
        all_student_list.push({
          name: item_temp.name,
          student_uuid: item_temp.student_uuid,
          grade: "未提交",
          precision_num: 0,
        });
      }

      // console.log(this.summary.precision_statistics_list)
      console.log(this.summary, "====");
      console.log(all_student_list);
      this.all_student_list_flower = all_student_list;
      // let all_student_grade=
    },
    // 切换发送小红花模式
    change_send_type() {},
    // 单独发送小红花
    send_flower_once(item) {
      // console.log(item)
      this.send_flower_once_dia = true;
      this.student_info = item;
      this.flower_num_once = 0;
      this.flower_once_reason = "";
    },
    send_flower_once_confirm() {
      // console.log(this.student_info)
      // console.log(this.flower_num_once)
      // console.log(this.flower_once_reason)
      let formData = {};
      formData.scene_name = "homework_usages";
      formData.scene_id_or_uuid = this.$route.query.homework_src_uuid;
      formData.student_list = [
        {
          reason: this.flower_once_reason
            ? this.flower_once_reason
            : "作业：" + this.$route.query.homework_title,
          student_uuid: this.student_info.student_uuid,
          score: this.flower_num_once,
        },
      ];
      this.axios.post("/school/coin_log/send", formData).then((res) => {
        if (res.data.code == 1) {
          this.$message({
            type: "success",
            message: res.data.msg,
          });
          this.send_flower_once_dia = false;
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
          });
        }
        // console.log(res)
      });
    },
    // 集体发送小红花
    send_flower() {
      let all_student_grade = [];
      // 优秀
      for (let i in this.summary.precision_statistics_list[0]) {
        let item_temp = this.summary.precision_statistics_list[0][i];
        all_student_grade.push({
          student_uuid: item_temp.student_uuid,
          score: this.excellent_flower,
          reason:
            "作业（" + this.$route.query.homework_title + "）完成情况：优秀",
        });
      }
      // 良好
      for (let i in this.summary.precision_statistics_list[1]) {
        let item_temp = this.summary.precision_statistics_list[1][i];
        all_student_grade.push({
          student_uuid: item_temp.student_uuid,
          score: this.fine_flower,
          reason:
            "作业（" + this.$route.query.homework_title + "）完成情况：良好",
        });
      }
      // 及格
      for (let i in this.summary.precision_statistics_list[2]) {
        let item_temp = this.summary.precision_statistics_list[2][i];
        all_student_grade.push({
          student_uuid: item_temp.student_uuid,
          score: this.pass_flower,
          reason:
            "作业（" + this.$route.query.homework_title + "）完成情况：及格",
        });
      }
      // 不及格
      for (let i in this.summary.precision_statistics_list[3]) {
        let item_temp = this.summary.precision_statistics_list[3][i];
        all_student_grade.push({
          student_uuid: item_temp.student_uuid,
          score: this.fail_flower,
          reason:
            "作业（" + this.$route.query.homework_title + "）完成情况：不及格",
        });
      }
      // 未提交
      for (let i in this.summary.un_submit_list) {
        let item_temp = this.summary.un_submit_list[i];
        all_student_grade.push({
          student_uuid: item_temp.student_uuid,
          score: this.un_submit_flower,
          reason:
            "作业（" + this.$route.query.homework_title + "）完成情况：未提交",
        });
      }
      let formData = {};
      formData.scene_name = "homework_usages";
      formData.scene_id_or_uuid = this.$route.query.homework_src_uuid;
      formData.student_list = all_student_grade;

      this.axios.post("/school/coin_log/send", formData).then((res) => {
        if (res.data.code == 1) {
          this.$message({
            type: "success",
            message: "小红花已发送",
          });
          this.dialogVisible_flower = false;
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
          });
        }
        // console.log(res)
      });
    },
    //获取学生答题情况
    get_correct_work() {
      var formData = new FormData();
      formData.append("class_id", this.$route.query.class_id);
      formData.append("batch_id", this.$route.query.batch_id);
      formData.append("homework_src_uuid", this.$route.query.homework_src_uuid);

      this.axios
        .post(`/school/Homework_Usages/homeworkUsagesBatchDetail`, formData)
        .then((res) => {
          let arr = res.data.data.data;
          this.chapter_code = res.data.data.chapter_code;
          this.attachfile = res.data.data.attachfile
            ? JSON.parse(res.data.data.attachfile)
            : [];
            console.log(this.attachfile)
          for (let i in this.attachfile) {
            let str = this.attachfile[i].name.substring(
              this.attachfile[i].name.lastIndexOf(".") + 1
            );
            this.attachfile[i].type = str;
            this.attachfile[i].url =
              JSON.parse(sessionStorage.userInfo).school.server_url +
              this.attachfile[i].url;
          }
          let student_arr = [];
          let topiclist = [];
          for (let i in arr) {
            let student_usages_json = JSON.parse(arr[i].student_usages_json);
            student_arr.push({
              name: arr[i].name,
              score: 0,
              score_all: 0,
              accuracy: 0,
            });
            for (let j in student_usages_json) {
              for (let h in student_usages_json[j].topicList) {
                if (i == 0) {
                  topiclist.push({
                    score: 0,
                    uuid: student_usages_json[j].topicList[h].uuid,
                    src_score: student_usages_json[j].topicList[h].src_score,
                  });
                }
                student_arr[i].score_all += student_arr[i].src_score || 5;
                if (!Array.isArray(student_usages_json[j].topicList[h].score)) {
                  if (student_usages_json[j].topicList[h].score > 0) {
                    student_arr[i].score =
                      Number(student_arr[i].score) +
                      Number(student_usages_json[j].topicList[h].score);
                  }
                } else {
                  let score = 0;
                  for (let i in student_usages_json[j].topicList[h].score) {
                    score =
                      score +
                      Number(student_usages_json[j].topicList[h].score[i]);
                  }
                  student_usages_json[j].topicList[h].score = score;
                }
              }
            }
            student_arr[i].accuracy = (
              (student_arr[i].score * 100) /
              student_arr[i].score_all
            ).toFixed(2);
          }

          for (let i in topiclist) {
            for (let j in arr) {
              let student_usages_json = JSON.parse(arr[j].student_usages_json);
              let arr_temp = [];
              for (let h in student_usages_json) {
                for (let o in student_usages_json[h].topicList) {
                  arr_temp.push(student_usages_json[h].topicList[o]);
                }
              }
              if (!Array.isArray(arr_temp[i].score)) {
                if (arr_temp[i].score > 0) {
                  //  console.log(student_usages_json[h].topicList[i].score)
                  topiclist[i].score =
                    Number(topiclist[i].score) + Number(arr_temp[i].score);
                }
              } else {
                let score = 0;
                for (let a in arr_temp[i].score) {
                  score = score + Number(arr_temp[i].score[a]);
                }
                topiclist[i].score = Number(topiclist[i].score) + Number(score);
              }
            }
            if (res.data.data.summary.submit_num > 0) {
              topiclist[i].accuracy =
                ((
                  (topiclist[i].score * 100) /
                  (res.data.data.summary.submit_num * topiclist[i].src_score ||
                    5)
                ).toFixed(2) *
                  100) /
                100;
            } else {
              topiclist[i].accuracy = 0;
            }
          }
          //自己算优秀良好
          for (let index in arr) {
            if (
              Number(arr[index].precision_num) >=
              arr[index].total_score * (this.parameter.excellent / 100)
            ) {
              res.data.data.summary.precision_statistics_list[0].push(
                arr[index]
              );
            }
            if (
              Number(arr[index].precision_num) <
                arr[index].total_score * (this.parameter.excellent / 100) &&
              Number(arr[index].precision_num) >=
                arr[index].total_score * (this.parameter.good / 100)
            ) {
              res.data.data.summary.precision_statistics_list[1].push(
                arr[index]
              );
            }
            if (
              Number(arr[index].precision_num) <
                arr[index].total_score * (this.parameter.good / 100) &&
              Number(arr[index].precision_num) >=
                arr[index].total_score * (this.parameter.pass / 100)
            ) {
              res.data.data.summary.precision_statistics_list[2].push(
                arr[index]
              );
            }
            if (
              Number(arr[index].precision_num) <
              arr[index].total_score * (this.parameter.pass / 100)
            ) {
              res.data.data.summary.precision_statistics_list[3].push(
                arr[index]
              );
            }
          }

          this.student_arr = student_arr;
          for (let i in arr) {
            arr[i].student_usages_json = JSON.parse(arr[i].student_usages_json);
          }
          this.achievementList = arr;
          for (let i in this.achievementList) {
            this.achievementList[i].topiclist = [];
            //console.log(this.achievementList[i].student_usages_json)
            for (let num in this.achievementList[i].student_usages_json) {
              for (let a in this.achievementList[i].student_usages_json[num]
                .topicList) {
                this.achievementList[i].topiclist.push(
                  this.achievementList[i].student_usages_json[num].topicList[a]
                );
              }
            }
          }
          for (let i in this.achievementList) {
            for (let num in this.achievementList[i].topiclist) {
              if (Array.isArray(this.achievementList[i].topiclist[num].score)) {
                let score = 0;
                for (let s in this.achievementList[i].topiclist[num].score) {
                  score =
                    score +
                    Number(this.achievementList[i].topiclist[num].score[s]);
                }
                this.achievementList[i].topiclist[num].score = score;
              }
            }
          }
          this.achievementList.sort((a, b) => {
            return b.precision_num - a.precision_num;
          });
          let total_score = 0;
          this.achievementList.forEach((item) => {
            total_score = total_score + Number(item.precision_num);
          });
          this.average = (total_score / this.achievementList.length).toFixed(1);
          this.summary = res.data.data.summary;
          for (let i in this.summary.precision_statistics_list) {
            this.summary.precision_statistics_list[i].sort((a, b) => {
              return b.precision_num - a.precision_num;
            });
          }
          this.topic_detail_list = topiclist;
          this.fullScorequantity = 0;
          this.topic_detail_list.forEach((item) => {
            if (item.accuracy == 100) {
              this.fullScorequantity = this.fullScorequantity + 1;
            }
          });

          let wrongTopicList = [];
          this.achievementList.forEach((item) => {
            item.topiclist.forEach((topicItem) => {
              if (topicItem.score < topicItem.src_score) {
                let answerIincorrectly = [];
                answerIincorrectly.push(item.name);
                topicItem.answerIincorrectly = answerIincorrectly;
                wrongTopicList.push(topicItem);
              }
            });
          });

          const hash = {};
          const newArray = wrongTopicList.reduce((item, next) => {
            hash[next.uuid] ? "" : (hash[next.uuid] = true && item.push(next));
            return item;
          }, []);

          for (let i in newArray) {
            for (let num in wrongTopicList) {
              if (
                newArray[i].uuid == wrongTopicList[num].uuid &&
                newArray[i].answerIincorrectly.indexOf(
                  wrongTopicList[num].answerIincorrectly[0]
                ) == -1
              ) {
                newArray[i].answerIincorrectly.push(
                  wrongTopicList[num].answerIincorrectly[0]
                );
              }
            }
          }
          this.wrongTopicList = newArray; //全班错题集
          // console.log(this.student_arr,this.wrongTopicList,'===')

          //导出表格
          this.DetailsForm = this.achievementList;
          if (this.activeIndex == 1) {
            this.drawPieChart();
          }
        });
    },
    //生成饼图
    drawPieChart() {
      let data = [
        {
          value: this.summary.precision_statistics_list[0].length,
          name: `优秀（>=${this.parameter.excellent}%）`,
        },
        {
          value: this.summary.precision_statistics_list[1].length,
          name: `良好（>=${this.parameter.good}%）`,
        },
        {
          value: this.summary.precision_statistics_list[2].length,
          name: `及格（>=${this.parameter.pass}%）`,
        },
        {
          value: this.summary.precision_statistics_list[3].length,
          name: `不及格（<${this.parameter.pass}%）`,
        },
      ];
      this.student_arr_type = data;
      //  console.log(data)
      this.chartPie = echarts.init(document.getElementById("chartPie"));
      this.chartPie.setOption({
        tooltip: {
          trigger: "item",
        },
        legend: {
          bottom: "10px",
          left: "center",
        },
        series: [
          {
            name: "答题情况",
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: false,
                fontSize: "40",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: data,
            itemStyle: {
              normal: {
                color: function (params) {
                  //自定义颜色
                  let colorList = ["#69B4FF", "#FF9B36", "#E37CFD", "#FF3945"]; //定义颜色列表 方便不等长选项自行截取
                  return colorList[params.dataIndex];
                },
              },
            },
          },
        ],
      });
      // option && myChart.setOption(option);
    },
  },

  beforeDestroy() {},
};
</script>

<style >
.flower_dia .el-dialog__footer {
  text-align: center;
}
.flower_dia {
  border-radius: 18px;
}
.studen_list_dia {
  border-radius: 18px;
}
.flower_dia .el-dialog__footer .el-button {
  margin: 0 40px;
}
.grade_detail_item .el-progress-circle {
  width: 142px !important;
  height: 142px !important;
}
.el-table .warning-row {
  background: #f0f9eb;
}
</style>
<style scoped>

.wrapper {
  width: 75vw;
  background: #f2f9ff;
  height: calc(100vh - 142px);
  padding: 16px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  margin: 14px auto;
  overflow: hidden;
      border-radius: 12px;
  /* margin: 0 360px; */
}
.wrapper_pad {
  background: #f2f9ff;
  height: calc(100vh - 32px);
  padding: 16px;
  /* box-sizing: border-box; */
  display: flex;
  flex-direction: column;
}
.head {
  height: 40px;
  line-height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  color: #69b4ff;
  margin-bottom: 20px;
  position: relative;
}
.head img {
  display: block;
  cursor: pointer;
  width: 24px;
  height: 20px;
}
.head_set_flower > div {
  /* margin-left: auto; */
  height: 40px;
  border: 2px solid #ffffff;
  cursor: pointer;
  background: radial-gradient(circle, #69b4ff 0%, #7dc6ff 100%);
  box-shadow: 0px 0px 4px 0px #2087ec;
  border-radius: 14px;
  line-height: 40px;
  padding: 0 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}
.report_content {
  /* background: red; */
  flex: 1;
  padding: 0 20px;
  overflow: auto;
}
.homework_title {
  height: 38px;
  line-height: 38px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  display: flex;
  margin-bottom: 20px;
}
.homework_title > div:nth-of-type(2) {
  background: #ffffff;
  border-radius: 20px 0px 20px 2px;
  margin-left: 20px;
  padding: 0 20px;
  min-width: 150px;
}
.item_title_detail {
  display: flex;
}
.item_title_detail > div:nth-of-type(2) {
  cursor: pointer;
  color: #69b4ff;
  margin-left: 20px;
}
.item_content {
  background: #ffffff;
  border-radius: 12px;
  display: flex;
  justify-content: space-between;
  padding: 20px;
  margin-top: 10px;
  margin-bottom: 20px;
}
.item_content2 {
  background: #ffffff;
  border-radius: 12px;
  display: flex;
  justify-content: space-between;
  padding: 20px 150px;
  margin-top: 10px;
  margin-bottom: 20px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #808080;
}
.item_content3 {
  background: #f2f9fe;
  border-radius: 12px;
  display: flex;
  justify-content: space-between;
  padding: 20px 150px;
  margin-top: 10px;
  margin-bottom: 40px !important;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #808080;
}

.fraction {
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  margin-bottom: 3px;
}
.item_content_item {
  background: #f4faff;
  border-radius: 46px 12px 46px 12px;
  width: 25%;
  font-size: 12px;
  color: #999999;
  padding: 16px;
  line-height: 30px;
}
.item_content_item_title {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.item_content_item_data {
  display: flex;
}
.item_content_item_data > div:nth-of-type(2) {
  color: #69b4ff;
  margin-left: 20px;
}
.item_result {
  display: flex;
  background: #ffffff;
  border-radius: 12px;
  margin-top: 10px;
  margin-bottom: 20px;
}
.result_l {
}
#chartPie {
  width: 300px !important;
  height: 600px !important;
}
.result_r {
  flex: 1;
  border: 2px solid #69b4ff;
  border-radius: 12px 12px 12px 12px;
  margin: 20px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.result_r_head {
  height: 30px;
}
.result_r_head {
  display: flex;
  justify-content: space-around;
  padding: 10px 30px;
  cursor: pointer;
}
.student_arr_type_active {
  color: #69b4ff;
}
.result_r_content {
  flex: 1;
  overflow: auto;
  padding: 10px 30px;
  display: flex;
  align-content: flex-start;
  flex-wrap: wrap;
}
.result_r_contentBox {
  margin: 20px 40px;
  position: relative;

  border-radius: 26px 26px 26px 26px;
}
.result_r_content_item {
  background: #f4faff;
  border-radius: 26px 0px 0px 26px;
  padding: 10px 40px 10px 20px;
  height: 30px;
  line-height: 30px;
}
.scoreBox {
  width: 60px;
  height: 60px;
  border: 5px solid #69b4ff;
  border-radius: 100%;
  background: #ffffff;
  position: absolute;
  right: -50px;
}
.scoreNum {
  font-size: 20px;
  /* color: #69b4ff; */
}
.student_list_dia {
  margin-top: 20px;
}
.student_list_dia {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
}
.student_list_dia_item {
  height: 38px;
  background: #f4faff;
  border-radius: 20px 0px 20px 2px;
  padding: 0 20px;
  margin: 0 20px 20px 0;
  line-height: 38px;
}
.grade_detail {
  height: 424px;
  background: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.grade_detail > div:nth-of-type(1) {
  height: 28px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  line-height: 28px;
  margin: 20px;
}
.grade_detail_itemBox {
  width: 100%;
  flex: 1;
  overflow: auto;
  display: flex;
  flex-wrap: wrap;
  padding: 0 20px;
  box-sizing: border-box;
}
.grade_detail_item {
  width: 142px;
  cursor: pointer;
  margin-right: 25px;
  margin-bottom: 20px;
}

/* .grade_detail_item_circle{
        height: 82px;
        width: 82px;
        border-radius: 50%;
        line-height: 82px;
        text-align: center;
        background: #F3F3F3;
    } */
.grade_detail_item > div:nth-of-type(2) {
  text-align: center;
}
.achievementListBox {
  box-sizing: border-box;
  height: 100%;
  width: 90%;
  margin: 20px;
  overflow: auto;
  border: 1px solid #ebeef5;
}
.achievementListItem {
  width: 100px;
  height: 40px;
  display: inline-block;
  line-height: 40px;
  text-align: center;
}
.achievementListBoxHead {
  white-space: nowrap;
}
.achievementListBoxHeadActive {
  background: #edf4fa;
}
.marginB {
  margin-bottom: 20px;
}
.result_r_content {
  flex: 1;
  overflow: auto;
  padding: 10px 20px;
  display: flex;
  align-content: flex-start;
  flex-wrap: wrap;
}
.result_r_contentBox {
  margin: 40px 60px;
  position: relative;
  border-radius: 26px 26px 26px 26px;
  position: relative;
}
.result_r_content_item {
  background: #f4faff;
  border-radius: 26px 0px 0px 26px;
  padding: 10px 40px 10px 20px;
  height: 30px;
  line-height: 30px;
  cursor: pointer;
}
.scoreBox {
  width: 60px;
  height: 60px;
  border: 5px solid #69b4ff;
  border-radius: 100%;
  background: #ffffff;
  position: absolute;
  right: -50px;
}
.scoreNum {
  font-size: 20px;
  /* color: #69b4ff; */
}
.indexNum {
  width: 40px;
  height: 40px;
  border-radius: 100%;
  position: absolute;
  left: -20px;
  background: #ffffff;
}
.color1 {
  color: #69b4ff !important;
}
.color2 {
  color: #ff9b36 !important;
}
.color3 {
  color: #e37cfd !important;
}
.color4 {
  color: #fe3844 !important;
}
.scoreBox2 {
  width: 60px;
  height: 60px;
  border: 5px solid #ff9b36;
  border-radius: 100%;
  background: #ffffff;
  position: absolute;
  right: -50px;
}
.scoreBox3 {
  width: 60px;
  height: 60px;
  border: 5px solid #e37cfd;
  border-radius: 100%;
  background: #ffffff;
  position: absolute;
  right: -50px;
}
.scoreBox4 {
  width: 60px;
  height: 60px;
  border: 5px solid #fe3844;
  border-radius: 100%;
  background: #ffffff;
  position: absolute;
  right: -50px;
}
.nav {
  margin: 20px 200px;
}
.navItem {
  width: 120px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #8a9399;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.navItem span {
  display: block;
  margin-bottom: 8px;
}
.navItemActive {
  font-weight: bold;
  color: #69b4ff;
}
.navLine {
  width: 80px;
  height: 4px;
  background: #69b4ff;
  border-radius: 2px;
  opacity: 1;
}
.result_rTitle {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #808080;
  margin: 10px;
}
.studentListBox {
  width: 322px;
  height: 100%;
  background: #ffffff;
  border-radius: 12px;
  box-sizing: border-box;
  overflow-y: auto;
  margin-right: 16px;
  padding: 16px;
}
.topiclistBox {
  width:calc(75vw - 350px);
  overflow-y:auto;
}
.topiclistItemContent >>>img{
  width:100%;
}
.topiclistBoxHead {
  padding: 14px 16px;
  background: #ffffff;
  border-radius: 12px;
  margin-bottom: 16px;
}
.topiclistBoxHeadTitle {
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
}

.topiclistBoxHeadNum {
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #ff9b36;
}
.allStudent {
  height: 48px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #808080;
  text-align: center;
  line-height: 48px;
  background: #f2f2f2;
  border-radius: 8px;
  cursor: pointer;
  margin-bottom: 12px;
}
.activeallStudent {
  background: #69b4ff;
  color: #ffffff;
}
.studentItem {
  width: 48%;
  height: 40px;
  background: #f2f2f2;
  border-radius: 8px;
  display: inline-block;
  margin-bottom: 12px;
  margin-right: 5px;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
}
.activestudentItem {
  background: #69b4ff;
  color: #ffffff;
}
.topiclistBoxContent {
  padding: 16px;
  background: #ffffff;
  border-radius: 12px;
  box-sizing: border-box;
  overflow-y: auto;
}
.topiclistItem {
  padding: 15px;
  background: #f2f9fe;
  border-radius: 12px;
  margin-bottom: 16px;
}
.accuracyTitle {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #1a1a1a;
}
.analysis {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #1a1a1a;
  cursor: pointer;
}
.analysis img {
  width: 20px;
  height: 16px;
}
.topic_answer_analyzing2 {
  border: 1px solid #69b4ff;
  border-radius: 8px;
  padding: 13px;
  margin-top: 10px;
}
.topiclistItemLine {
  height: 1px;
  background: #cccccc;
  border-radius: 1px;
  margin: 16px 0px;
}
.topiclistItemFooter {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #1a1a1a;
  margin-bottom: 12px;
}
.topic_btnItem {
  padding: 8px 14px;
  background: #69b4ff;
  border-radius: 8px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  margin-left: 20px;
  cursor: pointer;
}
.tipTiku {
  width: 296px;
  height: 300px;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #69b4ff;
  border-radius: 20px;
  position: relative;
  font-size: 12px;
  position: fixed;
  top: 39%;
  margin-left: 1125px;
  padding: 13px;
}
.tipHead span {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.tikuListItem {
  margin-bottom: 16px;
}
.tikuTypeName {
  width: 100px;
}
.testList {
  width: 70px;
  background: #f9fcff;
  padding: 5px 0px;
  visibility: hidden;
  max-height: 160px;
  overflow-y: auto;
  box-sizing: border-box;
}
.tipBtn {
  padding: 12px 9px;
  background: #ff9b36;
  border-radius: 10px;
  color: #ffffff;
  cursor: pointer;
  width: 150px;
  margin: 0 auto;
}
.testQuestions {
  position: fixed;
  top: 40%;
  margin-left: 1425px;
  cursor: pointer;
}
.testQuestionsBox {
  width: 70px;
  height: 160px;
  background: #69b4ff;
  border-radius: 0px 20px 20px 0px;
  margin-right: 3px;
}
.testBtn {
  width: 70px;
  height: 23px;
  background: #ffffff;
  border: 1px solid #69b4ff;
  box-shadow: 0px 1px 8px 0px rgba(63, 145, 227, 0.35);
  border-radius: 0px 12px 0px 0px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #69b4ff;
  cursor: pointer;
}
.testQuestions span {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}
.tikuName {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  padding: 0px 5px;
}
.numClass {
  padding: 1px 10px;
  margin-top: 8px;
  line-height: 16px;
  color: #fff;
  font-size: 12px;
}
.testListItem {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  margin: 3px 0;
  cursor: pointer;
  text-align: center;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.testListItemActive {
  color: #69b4ff;
}
.testQuestions img {
  width: 34px;
  height: 35px;
  margin-top: 20px;
  margin-bottom: 5px;
}

.numClass {
  padding: 1px 10px;
  margin-top: 8px;
  line-height: 16px;
  background-color: #ff4848;
  border-radius: 8px;
  -webkit-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-timing-function: linear;
  animation-timing-function: linear;
  color: #fff;
  font-size: 12px;
}
.isShowTestList {
  visibility: visible;
}
.set_flower_box{
  position:absolute;
  right:0;
}
.homeWorkItemBtn {
  width: 100px;
  height: 36px;
  background: #54a9fd;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  line-height: 36px;
}
</style>